import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = sessionStorage.getItem("user_id"); // Giriş kontrolü

  if (!isLoggedIn) {
    return <Navigate to="/userlogin" replace />;
  }

  return children;
};

export default ProtectedRoute;
